import { IPackagingProcessingActivity } from './types'
import http from '../../../../http'
import { API_URL } from '../../../../const'

// D15: dedicated controller, not the food ProcessingActivity route.
const PACKAGING_PROCESSING_ACTIVITY_URL: string = `${API_URL}/PackagingProcessingActivity`

export const getPackagingProcessingActivity = (pieceId: string) =>
  http.get(`${PACKAGING_PROCESSING_ACTIVITY_URL}/${pieceId}`)

export const updatePackagingProcessingActivity = (
  pieceId: string,
  data: IPackagingProcessingActivity
) => http.put(`${PACKAGING_PROCESSING_ACTIVITY_URL}/${pieceId}`, { data })

export const publishPackagingProcessingActivity = (pieceId: string) =>
  http.post(`${PACKAGING_PROCESSING_ACTIVITY_URL}/publish/${pieceId}`)

export const unPublishPackagingProcessingActivity = (pieceId: string) =>
  http.delete(`${PACKAGING_PROCESSING_ACTIVITY_URL}/unpublish/${pieceId}`)

export const deletePackagingProcessingActivity = (pieceId: string) =>
  http.delete(`${PACKAGING_PROCESSING_ACTIVITY_URL}/${pieceId}`)

export const createPackagingProcessingActivity = data =>
  http.post(`${PACKAGING_PROCESSING_ACTIVITY_URL}`, { data })

export const getPackagingProcessingActivityConfiguration = () =>
  http.get(`${PACKAGING_PROCESSING_ACTIVITY_URL}/configuration`)
